__webpack_require__.p = "/chess-game/";